import React from 'react';

// The compliance progress bar, SEGMENTED by document state (approved /
// awaiting review / expiring soon / expired), with outstanding as the grey
// remainder. Shared so the /portal/compliance status card and the dashboard
// "Your compliance" card render the exact same bar off the same counts.
const BAR_SEGMENTS = [
  { key: 'approved',       color: 'linear-gradient(90deg, #92D400, #009159)' },
  { key: 'awaitingReview', color: '#2E8FA1' },
  { key: 'expiringSoon',   color: '#E89A2E' },
  { key: 'expired',        color: '#8E1B06' },
];

export default function ComplianceBar({ counts, className = '' }) {
  const total = counts?.total || 0;
  return (
    <div className={`h-2 bg-[#E6E9DA] rounded-full overflow-hidden flex ${className}`}>
      {total > 0 && BAR_SEGMENTS.map(seg => {
        const c = counts?.[seg.key] || 0;
        if (c <= 0) return null;
        return (
          <div
            key={seg.key}
            className="h-full transition-all duration-300"
            style={{ width: `${(c / total) * 100}%`, background: seg.color }}
          />
        );
      })}
    </div>
  );
}
